import React, { Component } from 'react'
import { connect } from 'react-redux'

import BkFlowPaymentForm from '../../components/payment/BkFlowPaymentForm'
import BkFlowPaymentCreditCard from '../../components/payment/BkFlowPaymentCreditCard'
import BkFlowPaymentSidebar from '../../components/payment/sidebar/BkFlowPaymentSidebar'
import TermsConditionsField from '../../components/forms/termsConditions/TermsConditionsField'
import BkFlowPolicies from '../../components/policies/BkFlowPolicies'
import BkFlowPaymentSubmit from '../../components/payment/BkFlowPaymentSubmit'
import fetchTransactionToken, { setPspSessionId } from '../../actions/fetchTransactionToken'

import { isValid, getFormSyncErrors } from 'redux-form'
import _ from 'lodash'
import yn from 'yn'

// Import reservation actions
import createCart from '../../actions/createCart'
import createReservation from '../../actions/createReservation'
import createRestaurantReservation from '../../actions/createRestaurantReservation'
import setActiveStep from '../../actions/activeStepActions'

import formatPrice from '../../utilities/currency/formatPrice'
import getCurrencySymbol from '../../utilities/currency/getCurrencySymbol'
import triggerCustomGaEvent from '../../utilities/analytics/triggerCustomGaEvent'

import '../../styles/css/components/payment/bk-flow-payment.css'

import '../../styles/css/base/forms.css'

import backArrow from '../../assets/icons/arrow-left.svg'
import dayjs from "dayjs";

class BkFlowPaymentContain extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}

	componentDidMount() {
		const { handleCreateCart } = this.props

		window.scrollTo(0,0)
		window.history.pushState( {} , '', '/book/pay?' + this.props.currentQuery.query )

		// Dispatch activeRoom GA events
		triggerCustomGaEvent('analytics-pageView', window.location.href)

		const urlData = this.props.urlData;
		const activeRoom = this.props.activeRoom;
		let roomName, roomRateCode, roomRatePlan, roomCode;

		if (_.get(activeRoom[0], '[0][0].roomDescription.name')) {
			roomName = activeRoom[0][0][0].roomDescription.name
		}

		if (_.get(activeRoom[0], '[0][0].roomTypeCode')) {
			roomCode = activeRoom[0][0][0].roomTypeCode
		}

		if (_.get(activeRoom[0], '[2][0].ratePlanName')) {
			roomRatePlan = activeRoom[0][2][0].ratePlanName
		}

		if (_.get(activeRoom[0], '[2][0].ratePlanCode')) {
			roomRateCode = activeRoom[0][2][0].ratePlanCode
		}

		const roomRates = activeRoom[0][0][0].viewExtensions.roomRates;
		const selectedRoomRate = roomRates.find((room) => room.ratePlanCode === roomRateCode);

		const startDate = dayjs(urlData.startDate)
		const endDate = dayjs(urlData.endDate)

		const days = endDate.diff(startDate, 'days');

		triggerCustomGaEvent('verb_begin_checkout', {
			arrival_date: urlData.startDate,
			departure_date: urlData.endDate,
			ecommerce: {
				items: [{
					item_name: roomName,
					item_id: roomCode,
					price: selectedRoomRate.rates[0].total.amountBeforeTax / days,
					item_brand: urlData.hotelCode,
					item_category: roomRatePlan,
					item_variant: roomRateCode,
					quantity: days,
				}]
			}
		})

		if (yn(process.env.REACT_APP_COMPONENT_ENABLE_STRUCTURED_SIDEBAR)) {
			document.getElementById('bk-flow-payment').classList.add('inc-structured-sidebar')
			document.getElementById('bk-flow-payment-content').classList.remove('u-container')
		}

		handleCreateCart()
	}

	// Render detailed or basic payment submission button
	renderPaymentBtnDetailed() {
		const {
			activeRoom,
			activeEnhancementData,
			activeCurrencyData,
			configData,
		} = this.props

		const hotelLabels = configData.hotel.labels[0]

		let roomTotalsSum = ''
		let roomTotalData = []
		let enhancementTotalData = []
		let enhancementTotalsSum = ''
		let grandTotalData = []
		let renderGrandTotal = ''
		let currencyCode = null
		let currencySymbol = null

		if (!_.isEmpty(activeRoom)) {
			const addTotals = (a, b) => a + b

			for (let roomKey in activeRoom) {

				// Build Room Total
				if (activeRoom[roomKey][1][0].rates[0].total.amountAfterTax) {
					roomTotalData.push(Number(activeRoom[roomKey][1][0].rates[0].total.amountAfterTax))
					roomTotalsSum = roomTotalData.reduce(addTotals)
				}

				// Build enhancement totals
				if (_.isEmpty(activeEnhancementData)) {

					// Set 0 if no activeEnhancements
					enhancementTotalData.push(0)
				} else {

					// Loop for related enhancements by roomGroup and roomType
					for (let enhancementKeys in activeEnhancementData) {
						if (
							activeEnhancementData[enhancementKeys].roomGroup === Number(roomKey) &&
							activeEnhancementData[enhancementKeys].roomType === activeRoom[roomKey][0][0].roomTypeCode
						) {
							enhancementTotalData.push(activeEnhancementData[enhancementKeys].enhancementApiData.price[0].base.amountAfterTax)
						} else {
							enhancementTotalData.push(0)
						}
					}
				}

				enhancementTotalsSum = enhancementTotalData.reduce(addTotals)

				// Set currency values from CRS
				if (_.get(activeRoom, '[0][1][0].rates[0].total.currency')) {
					currencyCode = activeRoom[0][1][0].rates[0].total.currency
					currencySymbol = getCurrencySymbol(currencyCode)
				}
			}

			// Create grand total data
			grandTotalData.push(roomTotalsSum, enhancementTotalsSum)
			const grandTotalSum = grandTotalData.reduce(addTotals)

			// Convert currency values from FOREX
			if (
				yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX)&&
				activeCurrencyData &&
				activeCurrencyData.exchangeRate &&
				activeCurrencyData.currencyCode
			) {
				currencyCode = activeCurrencyData.currencyCode

				if (activeCurrencyData.currencySymbol) {
					currencySymbol = activeCurrencyData.currencySymbol
				} else {
					currencySymbol = getCurrencySymbol(activeCurrencyData.currencyCode)
				}

				// Convert exchange of CRS total based on active FOREX value
				renderGrandTotal = formatPrice(grandTotalSum * activeCurrencyData.exchangeRate, 2)
			} else {
				// Format grand total
				renderGrandTotal = formatPrice(grandTotalSum, 2)
			}
		}

		return (
			<span>
				{ hotelLabels && hotelLabels.bookFor ? hotelLabels.bookFor : 'Book for' }&nbsp;
				{ currencySymbol }{ renderGrandTotal }&nbsp;
				{ hotelLabels && hotelLabels.andProceed ? hotelLabels.andProceed : 'and proceed' }
			</span>
		)
	}

	handleSubmitReservations = () => {
		const {
			submitReservationForm,
			activeRestaurantsData,
			handleFetchTransactionToken,
			handleRestaurantReservation,
		} = this.props

		if (process.env.REACT_APP_COMPONENT_DSP2_PROVIDER === 'accor') {
			handleFetchTransactionToken()
		} else {
			//Submit hotel booking for single/multi-room
			submitReservationForm()

			// Submit restaurant reservations if enabled and selected venues
			if (
				yn(process.env.REACT_APP_COMPONENT_ENABLE_RESTAURANT_RESERVATIONS) &&
				activeRestaurantsData
			) {
				for (const restaurantKey in activeRestaurantsData) {
					const currentRestaurant = activeRestaurantsData[restaurantKey]

					handleRestaurantReservation(currentRestaurant)
				}
			}
		}
	}

	render() {
		const {
			activeCartData,
			activeStep,
			configData,
			dsp2TransactionLoading,
			guestFormErrors,
			handleBreadcrumbStep,
			isGuestValid,
			isPaymentValid,
			isTermsValid,
			paymentFormErrors,
			pspSessionIdLoading,
			reservationError,
			reservationLoading,
			termsFormErrors,
			transactionToken,
			transactionTokenLoading,
		} = this.props

		const hotelLabels = configData.hotel.labels[0]

		let submissionErrorsCount = null

		if (
			guestFormErrors &&
			paymentFormErrors &&
			termsFormErrors
		) {
			submissionErrorsCount = Object.keys(guestFormErrors).length + Object.keys(paymentFormErrors).length + Object.keys(termsFormErrors).length
		}

		// Enable button when Guest & Payment forms are valid
		let submitEnabled = isGuestValid === true && isPaymentValid === true && isTermsValid === true

		if (yn(process.env.REACT_APP_COMPONENT_ENABLE_CART)) {
			submitEnabled = !activeCartData.loading && !_.isEmpty(activeCartData.cart) && isGuestValid === true && isPaymentValid === true && isTermsValid === true
		}

		let baseFormClassNames = 'bk-flow-payment__terms u-form-card row start-xs between-sm middle-sm default'

		if (process.env.REACT_APP_COMPONENT_PAYMENT_FORMS_LAYOUT && yn(process.env.REACT_APP_COMPONENT_PAYMENT_BUTTON_FULL)) {
			baseFormClassNames = 'bk-flow-payment__terms u-form-card row start-xs inc-external-submit between-sm middle-sm ' + process.env.REACT_APP_COMPONENT_PAYMENT_FORMS_LAYOUT
		} else if (process.env.REACT_APP_COMPONENT_PAYMENT_FORMS_LAYOUT) {
			baseFormClassNames = 'bk-flow-payment__terms u-form-card row start-xs between-sm middle-sm ' + process.env.REACT_APP_COMPONENT_PAYMENT_FORMS_LAYOUT
		}

		const reservationErrorMessage = _.get(reservationError, 'response.data["hydra:description"]')

		return (
			<div
				id="bk-flow-payment"
				className="bk-flow-payment"
			>
				<div
					id="bk-flow-payment-content"
					className="u-container"
				>
					{ yn(process.env.REACT_APP_COMPONENT_PAYMENT_HEADING) &&
						<div className="bk-flow-payment__header">
							<h2 className="u-remove-margin">
								{ yn(process.env.REACT_APP_COMPONENT_BREADCRUMB_BACK_BUTTONS) &&
									<button
										className="btn btn-text-only"
										onClick={ () => handleBreadcrumbStep(activeStep - 1) }
									>
										<img src={ backArrow } alt="Return to rooms page" />
										{ hotelLabels && hotelLabels.backToEnhancements ? hotelLabels.backToEnhancements : 'Back to Enhancements' }
									</button>
								}

								{ hotelLabels && hotelLabels.payment ? hotelLabels.payment : 'Your Payment Information' }
							</h2>
						</div>
					}

					<div className="row">
						<div className="bk-flow-payment__main">
							<BkFlowPaymentForm />
							<BkFlowPaymentCreditCard />

							<div className={baseFormClassNames}>
								<div className="col-xs-12 start-xs">
									<h3>{ hotelLabels.termsConditions ? hotelLabels.termsConditions : 'Terms & Conditions' }</h3>
									<TermsConditionsField form="termsConditions" configData={ configData } />
									{ reservationErrorMessage ?
										<p className="u-font-sm submission-error" aria-live="assertive">
											{ reservationErrorMessage }
										</p>
									: reservationError && reservationError.message ?
										<p className="u-font-sm submission-error" aria-live="assertive">
											{ reservationError.message }
										</p>
									:
										 null
									}
								</div>

								{ !yn(process.env.REACT_APP_COMPONENT_PAYMENT_BUTTON_FULL)  &&
									<BkFlowPaymentSubmit
										dsp2TransactionLoading={dsp2TransactionLoading}
										isFormExternal={false}
										handleSubmitReservations={() => this.handleSubmitReservations()}
										hotelLabels={hotelLabels}
										pspSessionIdLoading={pspSessionIdLoading}
										reservationLoading={reservationLoading}
										renderPaymentBtnDetailed={this.renderPaymentBtnDetailed()}
										submitEnabled={submitEnabled}
										submissionErrorsCount={submissionErrorsCount}
										transactionToken={transactionToken}
									/>
								}
							</div>

							{ yn(process.env.REACT_APP_COMPONENT_PAYMENT_BUTTON_FULL) &&
								<BkFlowPaymentSubmit
									dsp2TransactionLoading={dsp2TransactionLoading}
									isFormExternal={true}
									handleSubmitReservations={() => this.handleSubmitReservations()}
									hotelLabels={hotelLabels}
									pspSessionIdLoading={pspSessionIdLoading}
									reservationLoading={reservationLoading}
									transactionTokenLoading={transactionTokenLoading}
									renderPaymentBtnDetailed={this.renderPaymentBtnDetailed()}
									submitEnabled={submitEnabled}
									submissionErrorsCount={submissionErrorsCount}
									transactionToken={transactionToken}
								/>
							}
						</div>

						{ !yn(process.env.REACT_APP_COMPONENT_ENABLE_STRUCTURED_SIDEBAR) &&
							<div className="bk-flow-payment__sidebar">
								<BkFlowPaymentSidebar />
							</div>
						}
					</div>

					{ yn(process.env.REACT_APP_COMPONENT_PAYMENT_PROPERTY_POLICIES) &&
						<BkFlowPolicies />
					}
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		currentQuery: state.availabilityData.currentQuery,
		urlData: state.availabilityData.urlData,
		availabilityData: state.availabilityData.availability,
		activeCartData: state.activeCartData,
		activeCurrencyData: state.activeCurrencyData,
		activeRoom: state.activeRoomData,
		activeRestaurantsData: state.activeRestaurantsData,
		activeEnhancementData: state.activeEnhancementData,
		dsp2TransactionLoading: state.dsp2TransactionData.loading,
		guestFormErrors: getFormSyncErrors('guestForm')(state),
		paymentFormErrors: getFormSyncErrors('paymentForm')(state),
		termsFormErrors: getFormSyncErrors('termsConditions')(state),
		isGuestValid: isValid('guestForm')(state),
		isPaymentValid: isValid('paymentForm')(state),
		isTermsValid: isValid('termsConditions')(state),
		activeStep: state.activeStepData.activeStep,
		reservationLoading: state.reservationData.loading,
		reservationError: state.reservationData.error,
		transactionTokenData: state.transactionTokenData.tokens,
		transactionTokenLoading: state.transactionTokenData.loading,
		pspSessionIdLoading: state.transactionTokenData.pspSessionIdLoading,
		paymentFormData: state.form.paymentForm,
	}
}

const mapDispatchToProps = dispatch => ({
	handleBreadcrumbStep(activeStep) {
		return dispatch(setActiveStep(activeStep))
	},
	handleCreateCart() {
		return dispatch(createCart())
	},
	handleRestaurantReservation(currentRestaurant) {
		return dispatch(createRestaurantReservation(currentRestaurant))
	},
	submitReservationForm(renewedSessionId, pspSessionId) {
		return dispatch(createReservation(renewedSessionId, pspSessionId))
	},
	// handlePspSessionIdLoading(isLoading) {
	// 	dispatch(fetchPspSessionIdLoading(isLoading))
	// },
	handleFetchTransactionToken() {
		dispatch(fetchTransactionToken())
	},
	handlePspSessionId(pspSessionId) {
		return dispatch(setPspSessionId(pspSessionId))
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowPaymentContain)


// WEBPACK FOOTER //
// ./src/containers/payment/BkFlowPaymentContain.js